var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-header-profile-menu"},[_c('CDropdownMenu',{attrs:{"menu-item-list-full":_vm.menuItemList},on:{"fullMenuToggle":_vm.handleMenuToggle,"linkClick":_vm.handleClickMenuItem}},[_c('CHeaderButton',{staticClass:"c-header-profile-menu__button",attrs:{"is-active":_vm.isMenuShow,"position":"bottom-left","icon":"profile"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }